export default __webpack_public_path__ + "static/media/Matsal4.c7f5fd61.jpeg";